import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class BrowserService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  /**
   * Safely access localStorage
   */
  getLocalStorage(key: string): string | null {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem(key);
    }
    return null;
  }

  /**
   * Safely set localStorage
   */
  setLocalStorage(key: string, value: string): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(key, value);
    }
  }

  /**
   * Safely remove from localStorage
   */
  removeLocalStorage(key: string): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem(key);
    }
  }

  /**
   * Safely access sessionStorage
   */
  getSessionStorage(key: string): string | null {
    if (isPlatformBrowser(this.platformId)) {
      return sessionStorage.getItem(key);
    }
    return null;
  }

  /**
   * Safely set sessionStorage
   */
  setSessionStorage(key: string, value: string): void {
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem(key, value);
    }
  }

  /**
   * Safely access document
   */
  getDocument(): Document | null {
    if (isPlatformBrowser(this.platformId)) {
      return document;
    }
    return null;
  }

  /**
   * Safely access window
   */
  getWindow(): Window | null {
    if (isPlatformBrowser(this.platformId)) {
      return window;
    }
    return null;
  }

  /**
   * Safely access navigator
   */
  getNavigator(): Navigator | null {
    if (isPlatformBrowser(this.platformId)) {
      return navigator;
    }
    return null;
  }

  /**
   * Check if running in browser
   */
  isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  /**
   * Execute function only in browser
   */
  executeInBrowser(fn: () => void): void {
    if (isPlatformBrowser(this.platformId)) {
      fn();
    }
  }

  /**
   * Get browser language
   */
  getBrowserLanguage(): string {
    if (isPlatformBrowser(this.platformId)) {
      return navigator.language.split('-')[0];
    }
    return 'en';
  }
}
